/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_AllInputs */



/**
* | output |
* | --- |
* | "Apply to All" |
*
* @param {Apply_To_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all = /** @type {((inputs?: Apply_To_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'appliquer à tous")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für alle gelten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica a tutti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применяется ко всем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar a todos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("适用于所有")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてに適用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी पर लागू होते हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar a todos")
	return /** @type {LocalizedString} */ ("Apply to All")
});